const keyboardAccessibility = require('base/components/keyboardAccessibility');

module.exports = () => {
  keyboardAccessibility(
    '.main-menu .nav-link, .main-menu .dropdown-link',
    {
      40(menuItem) {
        // down
        if (menuItem.hasClass('nav-item')) {
          // top level
          $('.navbar-nav .show')
            .removeClass('show')
            .children('.dropdown-menu')
            .removeClass('show');
          menuItem.addClass('show').children('.dropdown-menu').addClass('show');
          menuItem.find('ul > li > a').first().focus();
        } else {
          menuItem
            .removeClass('show')
            .children('.dropdown-menu')
            .removeClass('show');
          if (!(menuItem.next().length > 0)) {
            // if this is the last menuItem
            menuItem
              .parent()
              .parent()
              .find('li > a') // set focus to the first menuitem
              .first()
              .focus();
          } else {
            menuItem.next().children().first().focus();
          }
        }
      },
      39(menuItem) {
        // right
        if (menuItem.hasClass('nav-item')) {
          // top level
          menuItem
            .removeClass('show')
            .children('.dropdown-menu')
            .removeClass('show');
          $(this).attr('aria-expanded', 'false');
          menuItem.next().children().first().focus();
        } else if (menuItem.hasClass('dropdown')) {
          menuItem.addClass('show').children('.dropdown-menu').addClass('show');
          $(this).attr('aria-expanded', 'true');
          menuItem.find('ul > li > a').first().focus();
        }
      },
      38(menuItem) {
        // up
        if (menuItem.hasClass('nav-item')) {
          // top level
          menuItem
            .removeClass('show')
            .children('.dropdown-menu')
            .removeClass('show');
        } else if (menuItem.prev().length === 0) {
          // first menuItem
          menuItem
            .parent()
            .parent()
            .removeClass('show')
            .children('.nav-link')
            .attr('aria-expanded', 'false');
          menuItem
            .parent()
            .children()
            .last()
            .children() // set the focus to the last menuItem
            .first()
            .focus();
        } else {
          menuItem.prev().children().first().focus();
        }
      },
      37(menuItem) {
        // left
        if (menuItem.hasClass('nav-item')) {
          // top level
          menuItem
            .removeClass('show')
            .children('.dropdown-menu')
            .removeClass('show');
          $(this).attr('aria-expanded', 'false');
          menuItem.prev().children().first().focus();
        } else {
          menuItem
            .closest('.show')
            .removeClass('show')
            .closest('li.show')
            .removeClass('show')
            .children()
            .first()
            .focus()
            .attr('aria-expanded', 'false');
        }
      },
      27(menuItem) {
        // escape
        const parentMenu = menuItem.hasClass('show')
          ? menuItem
          : menuItem.closest('li.show');
        parentMenu.children('.show').removeClass('show');
        parentMenu
          .removeClass('show')
          .children('.nav-link')
          .attr('aria-expanded', 'false');
        parentMenu.children().first().focus();
      },
    },
    () => $(this).parent()
  );

  keyboardAccessibility(
    '.navbar-header .user',
    {
      40($popover) {
        // down
        if ($popover.children('a').first().is(':focus')) {
          $popover.next().children().first().focus();
        } else {
          $popover.children('a').first().focus();
        }
      },
      38($popover) {
        // up
        if ($popover.children('a').first().is(':focus')) {
          $(this).focus();
          $popover.removeClass('show');
        } else {
          $popover.children('a').first().focus();
        }
      },
      27() {
        // escape
        $('.navbar-header .user .popover').removeClass('show');
        $('.user').attr('aria-expanded', 'false');
      },
      9() {
        // tab
        $('.navbar-header .user .popover').removeClass('show');
        $('.user').attr('aria-expanded', 'false');
      },
    },
    () => {
      const $popover = $('.user .popover li.nav-item');
      return $popover;
    }
  );
};
